// Coordinate utilities for Konva (top-left origin, Y-axis down)
import { Vector2d } from "konva/lib/types";
import { Dimensions } from "@/shared";

export const transformCoordinate = (
  x: number,
  y: number,
  imageDimensions: Dimensions
): Vector2d => {
  const scaledX = x * imageDimensions.width;
  const scaledY = y * imageDimensions.height;

  return { x: scaledX, y: scaledY };
};

export const transformZoneCoordinate = (
  x: number,
  y: number,
  imageDimensions: Dimensions,
  imageSize: Dimensions
): Vector2d => {
  const scaledX = (x / imageSize.width) * imageDimensions.width;
  const scaledY = (y / imageSize.height) * imageDimensions.height; // Remove Y-axis flip for Konva

  return { x: scaledX, y: scaledY };
};

// Helper to convert Vector2d to flat array for Konva Line points
export const pointToArray = (point: Vector2d): [number, number] => [
  point.x,
  point.y,
];

// Helper to convert array of points to flat array for Konva
export const pointsToFlatArray = (points: Vector2d[]): number[] =>
  points.flatMap((point) => [point.x, point.y]);

// Helper to transform array of coordinate pairs from image coordinates to display coordinates
export const transformProjectionPoints = (
  projection: [number, number][],
  imageDimensions: Dimensions,
  imageSize: Dimensions
): Vector2d[] => {
  return projection.map(([x, y]) =>
    transformZoneCoordinate(x, y, imageDimensions, imageSize)
  );
};
